import { lazy } from 'react'
import { Route } from 'react-router-dom'
import { pageUrl } from '@/constants/url'

const SelectBranchPage = lazy(() => import('./pages/selectBranch'))
const SettingBranchPage = lazy(() => import('./pages/settingBranch'))
export const branchRoutes = () => {
  return (
    <>
      <Route path={pageUrl.branch} element={<SelectBranchPage />} />
      <Route path={pageUrl.branchSetting} element={<SettingBranchPage />} />
    </>
  )
}
